import _ from 'lodash';
import React, {useContext, useEffect, useRef} from "react";
import Chart from 'chart.js/auto';
import 'chartjs-adapter-dayjs-3';
import DateTimePeriod from "../../domain/DateTimePeriod";
import dayjs from "dayjs";
import {StatisticsServiceContext} from "../../Contexts";
import {ActiveElement, ChartEvent} from "chart.js";
import {useNavigate} from "react-router";
import {chartColors, defaultChartOptions} from "./ChartUtils";
import * as colors from '@ant-design/colors';

interface IProps {
    period: DateTimePeriod;
}

function CountryAuthRequestStatistics({period}: IProps) {
    const statisticsService = useContext(StatisticsServiceContext);
    const navigate = useNavigate();
    const chartElRef = useRef<HTMLCanvasElement>(null);
    const chartRef = useRef<Chart>();

    useEffect(() => {
        statisticsService.getStatistics(period, "countries").then(data => {
            const countries = _.uniq(data.map(value => value.country)).sort();

            const groupedData = _.groupBy(data, value => value.country);

            chartRef.current!.data.datasets = countries.map((value: any, index: number) => {
                return {
                    label: value,
                    stack: "",
                    data: groupedData[value].map(item => {
                        return {
                            x: new Date(item.dateTime).getTime(), y: item.count, country: item.country
                        }
                    }),
                    backgroundColor: (value === 'N/A') ? colors.grey[0] : chartColors[index]
                }
            });

            chartRef.current!.update();
        })

        chartRef.current = new Chart((chartElRef.current as HTMLCanvasElement),
            Object.assign(defaultChartOptions(period, onClick, []), {onClick})
        );

        return () => {
            chartRef.current?.destroy();
        }
    }, [period]);

    return (
        <canvas width="400" height="250" ref={chartElRef}/>
    )

    function onClick(_event: ChartEvent, elements: ActiveElement[], chart: Chart) {
        const element = elements[0];

        const item: any = chart.data.datasets[element.datasetIndex].data[element.index];

        if (item.country === 'N/A') {
            return;
        }

        const timestampFrom = dayjs(item.x).toISOString();
        const timestampTo = (period === DateTimePeriod.Day)
            ? dayjs(item.x).add(1, 'hour').toISOString()
            : dayjs(item.x).add(1, 'day').toISOString();

        const filter: any = {
            typeHints: {"timestampFrom": "dayjs", "timestampTo": "dayjs"},
            values: {
                types: ["AUTH_REQUEST_ADDED"],
                severity: "INFO",
                timestampFrom,
                timestampTo,
                attributes: [
                    {name: "geo_ident", value: item.country}
                ]
            }
        }

        const searchParams = new URLSearchParams();

        searchParams.set("filter", JSON.stringify(filter))

        navigate(`/audit-logs?${searchParams}`);
    }

}

export default CountryAuthRequestStatistics;
